import { render, staticRenderFns } from "./CmsAds.vue?vue&type=template&id=3749fe58&scoped=true"
import script from "./CmsAds.vue?vue&type=script&lang=js"
export * from "./CmsAds.vue?vue&type=script&lang=js"
import style0 from "./CmsAds.vue?vue&type=style&index=0&id=3749fe58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3749fe58",
  null
  
)

export default component.exports